var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 22.5C3.75 14.5444 3.75 10.5675 6.495 8.09625C9.24375 5.625 13.6612 5.625 22.5 5.625C31.3388 5.625 35.7581 5.625 38.5031 8.09625C41.2481 10.5675 41.25 14.5462 41.25 22.5C41.25 30.4538 41.25 34.4325 38.5031 36.9037C35.76 39.375 31.3388 39.375 22.5 39.375C13.6612 39.375 9.24188 39.375 6.495 36.9037C3.74812 34.4325 3.75 30.4538 3.75 22.5Z",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15H14.25C12.8362 15 12.1294 15 11.6888 15.4388C11.25 15.8813 11.25 16.5863 11.25 18V19.5C11.25 20.9137 11.25 21.6206 11.6888 22.0612C12.1313 22.5 12.8362 22.5 14.25 22.5H15.75C17.1637 22.5 17.8706 22.5 18.3112 22.0612C18.75 21.6187 18.75 20.9137 18.75 19.5V18C18.75 16.5863 18.75 15.8794 18.3112 15.4388C17.8687 15 17.1637 15 15.75 15Z",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 30H18.75M26.25 15H33.75M26.25 22.5H33.75M26.25 30H33.75",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon22);
export default __webpack_public_path__ + "static/media/icon22.88872d527d3e283dd567ac2b866a7aa7.svg";
export { ForwardRef as ReactComponent };